export default __webpack_public_path__ + "static/06.logo_dark-grey-bg-d1f375a09c51b0890e4adff7bdef6ba4.svg";